import { Link } from "gatsby"
import React from "react"
import styled, { css } from "styled-components"

export const OrangeButton: React.FC<{
  label: string
  withIcon?: boolean
  href: string
}> = ({ withIcon = false, label, href }) => {
  return (
    <Link to={href} style={{ color: "inherit" }}>
      <OrangeButtonAnchor withIcon={withIcon}>
        {withIcon && (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.5 19.5L11.5725 18.4552L5.8875 12.75L21 12.75V11.25L5.8875 11.25L11.5725 5.57025L10.5 4.5L3 12L10.5 19.5Z"
              fill="#EF7A00"
            />
          </svg>
        )}
        <span>{label}</span>
      </OrangeButtonAnchor>
    </Link>
  )
}

const OrangeButtonAnchor = styled.div<{ withIcon?: boolean }>`
  text-decoration: none;
  display: flex;
  width: 270px;
  height: 54px;
  flex-shrink: 0;
  border-radius: 27px;
  background-color: transparent;
  border: 2px solid var(--EF7A00_asial, #ef7a00);
  color: var(--EF7A00_asial, #ef7a00);
  cursor: pointer;
  text-align: center;
  align-items: center;
  transition: all 0.3s;
  position: relative;
  z-index: 1;
  justify-content: center;

  span {
    font-family: san-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: bold;
    line-height: normal;
    text-transform: uppercase;
  }
  ${({ withIcon }) =>
    withIcon &&
    css`
      justify-content: flex-start;
      svg {
        margin-left: 14px;
        flex: 0 0 24px;
      }
      span {
        flex: 1 1 auto;
        margin-left: -38px;
      }
    `}
  &:before {
    content: "";
    position: absolute;
    z-index: -1;
    transition: all 0.3s;
    background-color: #ef7a00;
    left: 0;
    top: -2px;
    height: 100%;
    border-radius: 2.4rem;
    width: 0%;
    opacity: 0;
  }
  &:hover {
    color: #fff;
    border: 2px solid #ef7a00;
    &:before {
      width: calc(100% + 4px);
      height: calc(100% + 4px);
      left: -2px;
      top: -2px;
      opacity: 1;
      border-radius: 27px;
    }
    > svg path {
      fill: #ffffff !important;
    }
  }
  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: -2;
  }
`
